import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {DictionaryService} from "@amlCore/services";
import {IDictItemType} from "@amlCore/interfaces";
import {ClientTypeEnum} from "@amlCore/enums";
import {Unsubscribable} from "rxjs";
import {Qref281fzService} from "../qref281fz.service";
import {Utils} from "@amlCore/utils";
import {AlertPanelComponent, AlertPanelService} from "@amlCore/components";
import {ActivatedRoute, Router} from "@angular/router";
import {ConfirmComponent} from "@amlCore/modals";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-internal',
  templateUrl: './qref281fz.component.html'
})
export class Qref281fzComponent implements OnInit, OnDestroy {
  @ViewChild('alertObjSave', {static: true}) alertPanelComponent: AlertPanelComponent;
  id: string; // id записи (если есть - форма редактирования/просмотра)
  submitted = false;
  form: FormGroup;
  ClientTypeEnum = ClientTypeEnum;
  clientTypeField = { // Поля для разблокировки по группе
    '1': ['orgNameRu', 'orgNameIn', 'regNum'], // Юридическое лицо
    '2': ['allName', 'birthDate'], // Физическое лицо
  };
  unsubList: Unsubscribable[] = [];
  clientTypeList: IDictItemType[] = [];
  goBack = Utils.goBack;

  constructor(private dictSrv: DictionaryService,
              private qref281fzService: Qref281fzService,
              private alertPanelSrv: AlertPanelService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
    this.initForm(); // Создаем форму
    this.initDict(); // Подгружаем справочники
    this.initData(); // Получаем данные
    this.initSub(); // Устанавливаем подписки
  }

  /**
   * Инициализация формы
   */
  private initForm(): void {
    this.form = this.qref281fzService.getForm();
  }

  /**
   * Инициализация справочников
   */
  private initDict(): void {
    this.dictSrv.loadTypeClient().then(result => {
      this.clientTypeList = result.filter((item: IDictItemType) => ['1', '2'].includes(item.code));
    });
  }

  /**
   * Инициализация подписок
   */
  private initSub(): void {
    const unsub = this.f('type').valueChanges.subscribe(uchType => {
      this.initUchType(uchType);
    });
    this.unsubList.push(unsub);
  }

  /**
   * Инициализация данных
   */
  private initData(): void {
    this.id = this.activatedRoute.snapshot.params.id;
    if (this.id) {
      this.qref281fzService.getQref281fz(this.id).subscribe(data => {
        if (data.type) {
          this.form.patchValue(data);
          this.form.markAsPristine();
          this.initUchType(data.type);
        }
      });
    }
  }

  /**
   * Инициализация типа лица
   * открыти/скрытия части полей
   * @param uchType - тип лица
   */
  initUchType(uchType: string): void {
    Object.keys(this.clientTypeField).forEach(key => {
      const fields: string[] = this.clientTypeField[key];
      if (uchType && uchType === key) {
        fields.forEach(field =>{
          this.f(field).enable();
        })
      } else {
        fields.forEach(field =>{
          this.f(field).disable();
        })
      }
    });
  }

  /**
   * Сохранение
   */
  save(): void {
    if (this.form.invalid) {
      this.submitted = true;
      this.alertPanelComponent.open(this.alertPanelSrv.getErrorMsg('Необходимо заполнить обязательные поля'));
      return;
    }
    const value = this.form.value;
    this.qref281fzService.saveQref281fz(value).subscribe(data => {
      if(data === 409){
        const modal = this.modalService.open(ConfirmComponent);
        modal.componentInstance.title = "Внимание";
        modal.componentInstance.text = "Клиент уже зарегистрирован в клиентской базе. Сохранение невозможно. Совпадающие значения будут выведены в отчет.";
        modal.componentInstance.okBtn = "Ок";
        modal.componentInstance.cancelBtn = "Отмена";
        modal.componentInstance.hideCloseBtn = true;
        modal.result.then(() => {
        }, () => {});
      } else if (!this.id) {
        this.router.navigate(['/registries/281fz', data.id], {replaceUrl: true});
      } else {
        this.form.markAsPristine();
        this.alertPanelComponent.open(this.alertPanelSrv.getSuccessMsg('Данные успешно сохранены'));
      }
    });
  }

  f(field: string) {
    return this.form.get(field);
  }

  ngOnDestroy(): void {
    this.unsubList.forEach(sub => sub.unsubscribe());
  }
}
